import { axiosWithToken } from "@/utils/axios";
import { AxiosResponse } from "axios";
import {
  RecommendPropertyBody,
  RecommendPropertyResponseData,
} from "@/types/realtors";
import { Project } from "@/types/project";
import { GetPropertyByUserResponse } from "@/types/property";

class ServiceClass {
  getPartnerRealtors(payload?: any) {
    return axiosWithToken().get("/realtors/partners", {
      params: payload,
    });
  }

  getAllRealtors(payload?: any) {
    return axiosWithToken().get("/realtors", {
      params: payload,
    });
  }

  realtorUpgrade(payload?: any) {
    const { id, ...data } = payload;
    return axiosWithToken().put(`/realtors/${id}/upgrade`, data);
  }

  becomePartnerRealtor(payload?: any) {
    return axiosWithToken().post(`/realtors/partners`, payload);
  }

  viewOpenRequests(payload?: any): Promise<
    AxiosResponse<{
      status: string;
      message: string;
      data: Project[];
    }>
  > {
    return axiosWithToken().get("/realtors/view-open-requests", {
      params: payload,
    });
  }

  recommendProperty(
    projectId: string,
    body: RecommendPropertyBody,
  ): Promise<AxiosResponse<RecommendPropertyResponseData>> {
    return axiosWithToken().post<RecommendPropertyResponseData>(
      `/realtors/projects/${projectId}/recommend-property`,
      body,
    );
  }

  getRealtorById(realtorId: string) {
    return axiosWithToken().get(`/realtors/${realtorId}`);
  }

  getPropertiesByRealtor(
    realtorId: string,
    params?: {
      pageNumber?: number;
      pageSize?: number;
      cursor?: string;
      beforeCursor?: string;
      location?: string;
      listingType?: string;
      propertyType?: string;
      status?: string;
    },
  ): Promise<AxiosResponse<GetPropertyByUserResponse>> {
    return axiosWithToken().get(`/realtors/${realtorId}/properties`, {
      params,
    });
  }
}

const RealtorService = new ServiceClass();
export default RealtorService;
